import React, { useCallback } from 'react';
import Dropdown from './Dropdown';

function FacetedSearchGroup({ group, facetFilters, onFacetChange }) {
  const onSelect = useCallback(
    (item) => {
      onFacetChange(group, item);
    },
    [group]
  );

  function isSelected(item) {
    return group.selectedOptions?.includes(item.id) === true;
  }

  if (!group.options?.length) {
    return null;
  }
  const options = group.options;

  if (options?.length > 0)
    options.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <li className="faceted-search__group columns small-6 medium-4 large-2">
      <Dropdown
        label={group.label}
        className="facet-filter-dropdown flyout-filters"
      >
        {options.map((item, itemIndex) => (
          <Dropdown.Item
            key={`${item.label}-${itemIndex}`}
            className="facet-filter-dropdown__item-wrapper"
          >
            <label className="facet-filter-dropdown__item">
              <span className="facet-filter-dropdown__label">
                {item.label} ({item.quantity})
              </span>
              <input
                type="checkbox"
                checked={isSelected(item)}
                onChange={() => onSelect(item)}
                className="facet-filter-dropdown__input"
              />
            </label>
          </Dropdown.Item>
        ))}
      </Dropdown>
    </li>
  );
}

export function FacetedSearch({ facetFilters, onFacetChange }) {
  if (!facetFilters?.length) {
    return null;
  }

  return (
    <ul
      role="menu"
      className="faceted-search faceted-search--compact row align-bottom"
    >
      {facetFilters.map((group, groupIndex) => (
        <FacetedSearchGroup
          key={`${group.label}-${groupIndex}`}
          group={group}
          facetFilters={facetFilters}
          onFacetChange={onFacetChange}
        />
      ))}
    </ul>
  );
}

export default FacetedSearch;
